import { CellTable } from "@/atoms"
import { AgentPlatformIcon } from "@/molecules/AgentPlatformIcon"
import { EmptyValue } from "@/molecules/ChipsCell"
import { IconTextCell } from "@/molecules/IconTextCell"
import { ResourceCell } from "@/pages/TriagePage/components/molecules/ResourceCell"

import type { SourceCellProps, SourceCellRecord } from "./SourceCell.types"

// Where an AI component comes from: its project's code repository or
// application, or the agent platform's scope hosting it
export const SourceCell = (props: SourceCellProps) => {
  const projectCell = ResourceCell(props)

  return function SourceCellComponent(value: string, record: SourceCellRecord) {
    const { projectName, platformDetails } = record

    if (!projectName) return <EmptyValue />

    // A platform's scope is no code repository: its platform's icon, not a
    // source control one
    if (record.type !== "AgentPlatform") return projectCell(value, record)

    const platformKey = platformDetails?.platformKey

    if (!platformKey) return CellTable(projectName)

    return (
      <IconTextCell
        icon={<AgentPlatformIcon platform={platformKey} />}
        text={projectName}
      />
    )
  }
}
